var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSpeech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: "64px",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.964,8.127H16.036c-4.4,0-8,3.6-8,8v20.977c0,4.4,3.6,8,8,8h7.397v10.768l13.333-10.768h11.197c4.4,0,8-3.6,8-8V16.127   C55.964,11.727,52.364,8.127,47.964,8.127z M50.964,37.104c0,1.626-1.374,3-3,3H36.767H35l-1.375,1.11l-5.191,4.193v-0.303v-5h-5   h-7.397c-1.626,0-3-1.374-3-3V16.127c0-1.626,1.374-3,3-3h31.928c1.626,0,3,1.374,3,3V37.104z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 21.743,
    cy: 26.617,
    r: 2.913
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32,
    cy: 26.617,
    r: 2.913
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 42.256,
    cy: 26.617,
    r: 2.913
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSpeech);
export default __webpack_public_path__ + "static/media/menuSpeech.51b17918a3f19a31bc7827b64bfbfbdc.svg";
export { ForwardRef as ReactComponent };